module.exports = __webpack_public_path__ + "img/motor_no43.5ab2cf64.jpg";